<template>
	<div class="container">
		<div v-if="provider && shouldContinue">
			<component :is="providerComponent" @loading="setLoading" />
		</div>

		<div v-if="error && !shouldContinue" class="error">
			<text-headline-primary>
				{{ texts.error_title }}
			</text-headline-primary>
			<p>{{ texts.error_code }}: {{ error }}</p>
			<text-button @click.prevent="retry">
				{{ texts.retry }}
			</text-button>
		</div>

		<div v-if="!provider && !error" class="providers">
			<text-headline-primary>Vælg betalingsmetode</text-headline-primary>
			<ul>
				<li v-for="p in providers" :key="p">
					<text-button @click="setPaymentProvider(p)">
						{{ p }}
					</text-button>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import PaymentDibs from '@/components/payment/PaymentDibs'
import PaymentDibsEasy from '@/components/payment/PaymentDibsEasy'
import PaymentEpay from '@/components/payment/PaymentEpay'
import PaymentNetaxept from '@/components/payment/PaymentNetaxept'
import PaymentDeveloper from '@/components/payment/PaymentDeveloper'
import PaymentFree from '@/components/payment/PaymentFree'
import TextButton from '@/components/elements/TextButton'
import { mapGetters } from 'vuex'

export default {
	components: {
		PaymentDibs,
		PaymentDibsEasy,
		PaymentEpay,
		PaymentNetaxept,
		PaymentDeveloper,
		PaymentFree,
		TextButton,
	},
	data() {
		return {
			userSelectedProvider: null,
		}
	},
	computed: {
		texts() {
			return this.$t('page_payment')
		},
		provider() {
			if (this.priceOre === 0) return 'Free'
			if (this.userSelectedProvider) return this.userSelectedProvider
			if (process.env.VUE_APP_SERVER === 'live') return this.realProvider
			if (this.providers.length === 1) return this.providers[0]
			return null
		},
		providerComponent() {
			switch (this.provider) {
				case 'Dibs':
					return 'PaymentDibs'
				case 'DibsEasy':
					return 'PaymentDibsEasy'
				case 'Epay':
					return 'PaymentEpay'
				case 'Netaxept':
					return 'PaymentNetaxept'
				case 'Developer':
					return 'PaymentDeveloper'
				case 'Free':
					return 'PaymentFree'
				default:
					return null
			}
		},
		realProvider() {
			return process.env.VUE_APP_PAYMENT_PROVIDER
		},
		providers() {
			const providers = [this.realProvider]
			if (process.env.VUE_APP_SERVER !== 'live') providers.push('Developer')
			return providers
		},
		shouldContinue() {
			if (this.userSelectedProvider) return true
			if (this.error) return false
			return true
		},
		...mapGetters({
			error: 'order/getPaymentProviderError',
			priceOre: 'order/getPriceOre',
		}),
	},
	mounted() {
		const storage = {
			productType: this.$store.getters['order/getProductType'],
			orderId: this.$store.getters['order/getOrderId'],
			priceOre: this.$store.getters['order/getPriceOre'],
			details: this.$store.getters['order/getDetails'],
			deliveryMethod: this.$store.getters['order/getDeliveryMethod'],
			flowType: this.$store.getters['flow/getType'],
			flowStep: this.$store.getters['flow/getStep'],
			locale: this.$i18n.locale,
		}

		this.$cookies.set(`order-${storage.orderId}`, JSON.stringify(storage), '30min')
	},
	methods: {
		setPaymentProvider(provider) {
			this.$store.commit('order/setForcePaymentProvider', provider)
			this.userSelectedProvider = provider
		},
		retry() {
			this.setPaymentProvider(this.realProvider)
		},
		setLoading(message) {
			if (!message) {
				this.$emit('loading', false)
			} else {
				this.$emit('loading', true, message)
			}
		},
	},
}
</script>

<style scoped>
.container {
	text-align: center;
}

.providers,
.error {
	margin-top: 4rem;
}

.providers h1 {
	padding: 0 1rem;
}

.providers ul {
	list-style: none;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	margin-top: 2rem;
	padding: 0 1rem;
	margin-left: -1rem;
}

.providers li {
	margin-bottom: 1rem;
	margin-left: 1rem;
}
</style>
